import moment from "moment-timezone";

export function buildDetailingDataFromPayload(p) {
  const salesGroup = p?.Group || "";

  const productNamesFromMap = p?.Sales_Group_Product_Map?.[salesGroup] || [];
  const productKeyMessages = Array.isArray(p?.Product_Key_Messages)
    ? p.Product_Key_Messages
    : [];

  const rowsForGroup = salesGroup
    ? productKeyMessages.filter((r) => r?.Sales_Group === salesGroup)
    : productKeyMessages;

  const productNames =
    productNamesFromMap.length > 0
      ? productNamesFromMap
      : rowsForGroup.map((r) => r?.ProductName).filter(Boolean);

  const uniqueProducts = Array.from(new Set(productNames));

  const products = uniqueProducts.map((name) => {
    const row =
      rowsForGroup.find((r) => r?.ProductName === name) ||
      productKeyMessages.find((r) => r?.ProductName === name);

    const ProductID = row?.ProductID || "";

    return {
      name,
      ProductID,
      keyMessages: row?.KeyMessages || [],
    };
  });

  return { salesGroup, products };
}

export function prefillRepTerritoryFromPayload(payload) {
  const u = payload?.user_details || payload || {};
  const repName =
    u?.Sales_Rep_Name ||
    payload?.Sales_Rep_Name ||
    payload?.SalesRepName ||
    "";
  const territory =
    u?.TerritoryDisplayName ||
    payload?.TerritoryDisplayName ||
    u?.TerritoryName ||
    payload?.TerritoryName ||
    "";
  return { salesRepName: repName, territoryName: territory };
}

/**
 * Assembles the request body for submitCallLog.
 */
export function buildCallLogSubmitBody({
  detailQuery,
  formData,
  selectedProducts,
  selectedKeyMessagesByProduct,
  promotionalItems,
  detailApiData,
  payload,
  hcps,
  hcos,
}) {
  const kmLookupById = (() => {
    const map = {};
    (detailApiData?.products || []).forEach((p) => {
      (p.keyMessages || []).forEach((km) => {
        const id = km?.KeyMessageID || km?.id;
        if (!id) return;
        map[id] = km;
      });
    });
    return map;
  })();

  const detailingProducts = (selectedProducts || []).map((productName) => {
    const pObj =
      (detailApiData?.products || []).find((p) => p?.name === productName) ||
      null;

    const productId = pObj?.ProductID || pObj?.productId || pObj?.id || "";

    const selectedKmIds = selectedKeyMessagesByProduct?.[productName] || [];

    const keyMessages = selectedKmIds.map((id) => {
      const full = kmLookupById[id];
      return (
        full || {
          KeyMessageID: id,
          KeyMessageName: "",
          KeyMessageDescription: "",
        }
      );
    });

    return {
      productName,
      ProductID: productId,
      keyMessages,
    };
  });

  const selectedHcps = (() => {
    const attendeeObjs = (formData.attendees || []).map((a) => {
      if (typeof a === "object" && a !== null) return a;

      const found =
        (hcps || []).find((h) => h?.DoctorID === a || h?.id === a) || null;

      return (
        found || {
          DoctorID: a,
        }
      );
    });

    const accountId = formData.accountName;
    const accountObj =
      (hcps || []).find(
        (h) => h?.DoctorID === accountId || h?.id === accountId,
      ) ||
      (accountId
        ? {
            DoctorID: accountId,
          }
        : null);

    if (formData.callType === "group") {
      return attendeeObjs;
    }

    return accountObj ? [accountObj] : [];
  })();

  const selectedHcoObj =
    formData.callType === "group"
      ? (hcos || []).find(
          (h) =>
            h?.InstitutionID === formData.institutionId ||
            h?.id === formData.institutionId,
        ) || null
      : null;

  return {
    prompt: detailQuery,

    professionalInfo: {
      salesRepName: formData.salesRepName,
      repEmail: payload?.Rep_Email || "",
      territoryDisplayName: payload?.TerritoryDisplayName || "",
      territoryName: payload?.TerritoryName || "",
      group: payload?.Group || "",
      salesRepID: payload?.sales_rep_ID || "",
      subject: formData.subject || "",

      callDateTime: formData.callDateTime
        ? moment(formData.callDateTime)
            .tz("America/New_York")
            .format("YYYY-MM-DDTHH:mm")
        : "",
      callDateTimeTimezone: "America/New_York",
      callDuration:
        formData.callDuration === "" || formData.callDuration == null
          ? 0
          : Number.parseInt(String(formData.callDuration), 10) || 0,
      callType: formData.callType,

      HCPs: selectedHcps,
      attendees: selectedHcps.length,

      HCO: selectedHcoObj,
    },

    detailingPriority: {
      salesGroup: detailApiData?.salesGroup || payload?.Group || "",
      products: detailingProducts,
    },

    promotional: promotionalItems,
  };
}
